import forestGif from "icons/forest/forest_red.gif"
import forestImg from "icons/forest/forest_red.jpg"

export default {
  gif: forestGif,
  img: forestImg,
}
